import { observer } from 'mobx-react-lite'
import Styles from './IntegrationsDrawer.module.scss'
import { ExternalIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ArrowRefresh2, Close } from 'blaze-ui/icons'
import { useConnectedAccountCardProps } from 'components/IntegrationsModal/ManageIntegrationAccounts/hooks'
import { useState } from 'react'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import { extractProfileInfo } from 'components/ExternalIntegrationSelect/utils'
import { Button } from 'blaze-ui/Button/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Check } from 'blaze-ui/icons/16'
import { PlatformIcon } from './PlatformIcon'

interface Props {
  integration: ExternalIntegration
}

export const Integration = observer(({ integration }: Props) => {
  const { onRefreshConnection, onDisconnectAccount } = useConnectedAccountCardProps(integration)
  const [imageDidError, setImageDidError] = useState(false)
  const { showAvatar, avatar, name, email, username } = extractProfileInfo(integration)
  const src = imageDidError ? Silhouette : avatar || Silhouette

  return (
    <div className={Styles.card}>
      <div className={Styles.header}>
        <div className={Styles.top}>
          {showAvatar && <img className={Styles.avatar} src={src} alt={name} onError={() => setImageDidError(true)} />}
          <PlatformIcon provider={integration.provider} size={28} />
        </div>
        <Heading lineClamp={1} level={5}>
          {name}
        </Heading>
        {(email || username) && (
          <div className={Styles.verification}>
            <div className={Styles.check}>
              <Check />
            </div>
            <Text color="var(--green-50)" variant="metadata">
              {email || username}
            </Text>
          </div>
        )}
      </div>
      <div className={Styles.actions}>
        {integration.provider !== ExternalIntegrationEnum.WordPress && (
          <Button
            fullWidth
            frontIcon={ArrowRefresh2}
            size="sm"
            variant="tertiary"
            onPress={() => onRefreshConnection()}
          >
            Refresh
          </Button>
        )}
        <Button fullWidth frontIcon={Close} size="sm" variant="tertiary" onPress={onDisconnectAccount}>
          Disconnect
        </Button>
      </div>
    </div>
  )
})
